import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Doughnut} from 'react-chartjs'
import config from '../../config'
import {
  LinkIcon,
} from '../../components'
import Styles from './PlanScorecardSustainableAccess.css'

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardSustainableAccess extends Component {
  static propTypes = {
    planData: PropTypes.object.isRequired,
    allocationStats: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)

    const { planData } = props
    const { plan_option_sri_count, plan_option_count } = planData
    const hasSustainableFundOptions = (
      plan_option_sri_count &&
      plan_option_sri_count > 0
    )

    this.state = {
      allocationStats: props.allocationStats,
      alertColor: hasSustainableFundOptions ? 'yellow' : 'red',
      alertText: hasSustainableFundOptions ?
        `Only ${plan_option_sri_count} / ${plan_option_count} plan options
          report a sustainability mandate.` :
        'No plan options report a sustainability mandate.',
      ledeText: hasSustainableFundOptions ?
        'But it\'s important to make sure sustainable funds are actually meeting your standards. The scorecard for any plan options marketed as sustainable can be seen below.' :
        'This plan has no investment options marketed as sustainable.'
    }
  }

  render() {
    const { allocationStats, alertColor, alertText, ledeText } = this.state

    //
    return (
      <div>
        <div styleName='results-subtitle'>
          <h2 styleName='results-subtitle-lbl'>
            Access to sustainable funds
          </h2>
          <div styleName='results-subtitle-clrbr' />
        </div>
        <div styleName='sublede-sustainable-count'>
          <div styleName={'sublede-sustainable-count-icon ' + alertColor}>
            <LinkIcon faclass='fa-exclamation-triangle fa-3x' nospace/>
          </div>
          <h3 styleName='sublede-sustainable-count-text'>
            {alertText}
          </h3>
        </div>
        <div styleName='chart-headline'>
          <Doughnut
            data={[
              { value: allocationStats.sri.perc,
                // label: 'Sustainable',
                color: '#313131' },
              { value: allocationStats.sri.percOther,
                // label: 'Other',
                color: '#D5D5D5' }
            ]}
            options={config.chartOptions}
            width='150'
            height='150'
          />
          <div>
            {
              allocationStats.sri.percStr === 'NaN%' ?
                null :
                (
                  <h3 styleName='chart-headline-text'>
                    {allocationStats.sri.percStr} of plan assets are invested in
                    sustainable options.
                  </h3>
                )
            }
            <div styleName='chart-sublede'>
              While many people stick with the target date option, 401(k)s and
              other employer-offered retirement plans usually have a line-up
              of additional investment options.
              Some of these investment options may be marketed as
              "sustainable", "socially
              responsible", or "ESG" (short for environment, social, and
              governance). Sustainable funds often seek to avoid investments
              in high-carbon companies and other environmentally and socially
              risky industries. {ledeText}
            </div>
          </div>
        </div>
      </div>
    )
  }
}